import React from 'react';
import Breadcrumb from './Breadcrumb';

const PageHeader = ({ items, pageTitle }) => {
    return (
        <div className="py-4 border-b">
            <Breadcrumb items={items} />
            <div className="mt-4">
                <span className="uppercase text-gray-600 dark:text-gray-200 font-bold ">{pageTitle}</span>
            </div>
        </div>
    );
};

export default PageHeader;
